/**
 * Merge additional fields into an already-serialized `generationSettings` JSON
 * string.
 *
 * Used when extra metadata (e.g. an AI-resolved style label) only becomes known
 * *after* the generation context was set but *before* the backend call that
 * persists it. Extra fields win over existing ones. An absent or unparseable
 * base yields a settings object containing just the extra fields.
 *
 * Kept free of Firebase imports so it can be unit-tested in isolation; callers
 * pass settings that were already serialized (and thus base64-stripped) plus
 * small scalar extras.
 */
export function mergeSerializedGenerationSettings(
  serialized: string | undefined,
  extra: Record<string, unknown>
): string {
  let current: Record<string, unknown> = {};
  if (serialized) {
    try {
      const parsed: unknown = JSON.parse(serialized);
      if (parsed && typeof parsed === "object") {
        current = parsed as Record<string, unknown>;
      }
    } catch {
      current = {};
    }
  }
  return JSON.stringify({ ...current, ...extra });
}
